import {
  AssignModel,
  createEconnectorClient,
  IdPathParameters,
  OwnerResponse,
  postRequestFactory,
  SaveOperation,
  SearchOperation,
  searchRequestFactory
} from '@infuse/api/common';

const client = createEconnectorClient('/api/centralsystems');

export const centralSystemAccessManagementPermissions = {
  ASSIGN: 'econnector.assign-central-system',
  UNASSIGN: 'econnector.unassign-central-system',
  SEARCH_OWNERS: 'econnector.search-central-system-owners'
};

export type AssignCentralSystemRequest = AssignModel;
export type UnassignCentralSystemRequest = AssignModel;

export const assignCentralSystem: SaveOperation<AssignCentralSystemRequest, void, number> = postRequestFactory<
  AssignCentralSystemRequest,
  void
>(client, {
  pattern: '/{id}/assign',
  permissionId: centralSystemAccessManagementPermissions.ASSIGN
});

export const unassignCentralSystem: SaveOperation<UnassignCentralSystemRequest, void, number> = postRequestFactory<
  UnassignCentralSystemRequest,
  void
>(client, {
  pattern: '/{id}/unassign',
  permissionId: centralSystemAccessManagementPermissions.UNASSIGN
});

export const getCentralSystemOwners: SearchOperation<OwnerResponse, IdPathParameters<number>> = searchRequestFactory<
  OwnerResponse,
  IdPathParameters<number>
>(client, {
  pattern: '/{id}/owners',
  permissionId: centralSystemAccessManagementPermissions.SEARCH_OWNERS
});
